import { render, staticRenderFns } from "./lack.vue?vue&type=template&id=098912ba&scoped=true&"
import script from "./lack.vue?vue&type=script&lang=js&"
export * from "./lack.vue?vue&type=script&lang=js&"
import style0 from "./lack.vue?vue&type=style&index=0&id=098912ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098912ba",
  null
  
)

export default component.exports